export const ANATOMY_COMPACT_BREAKPOINT = 660

export const anatomyCompact = `@media (max-height: ${ANATOMY_COMPACT_BREAKPOINT}px)`

export const ANATOMY_COMPACT = {
  fontSize: {
    f32: '22px',
    f24: '20px',
    f22: '18px',
    f15: '13px',
  },
  lineHeight: {
    lh38: '26px',
    lh30: '22px',
    lh28: '20px',
    lh20: '16px',
  },
  spacing: {
    s50: '20px',
    s32: '16px',
    s24: '6px',
  },
}
